export default __webpack_public_path__ + "static/media/Idle2.88996174.gif";